export const landingPageEventCategories = {
    searchSection: {
        SEARCH_BOX: 'Suche',
        BREADCRUMB: 'Main',
    },
    headerSection: {
        RENTAL: 'region',
        WISHLIST: 'Profile',
    },
    newsLetterSection: {
        REGISTER: 'Social',
    },
    listingCardSection: {
        TOP_INSERAT: 'Suche',
        WISHLIST_POP_UP: 'Wishlist',
    },
    stickyFooterSection: {
        STICKY_FOOTER: 'sticky_footer',
    },
    topRecommendationsSection: {
        TOP_CTA_VIEW_RECOMMENDATIONS: 'rlp_all_accommodation_top',
        BOTTOM_CTA_VIEW_RECOMMENDATIONS: 'rlp_all_accommodation_bottom',
    },
    bannerAdSection: {
        BANNER_CLICK: 'banner_ad',
    },
}
export const CommonPageEventCategories = {
    searchSection: {
        SEARCH_BOX: 'searchbox',
    },
    breadcrumbSection: {
        BREADCRUMB_SECTION: 'breadcrumb',
    },
}
export const searchResultListingsPageEventCategories = {
    listViewPageSpecific: {
        TO_BE_ADDED: 'to_be_added',
        VIEW_TOGGLE: 'view_toggle@srl',
    },
    mapViewPageSpecific: {
        mapSection: {
            MAP_SEARCH: 'suche@map_v2',
        },
    },
    tileViewPageSpecific: {
        TO_BE_ADDED: 'to_be_added',
    },
    filterSection: {
        FILTER_CLICK: 'resultfilter@',
    },
    instantBookingBannerSection: {
        TOGGLE: 'instant_booking_banner@srl',
    },
}

export const eventPageCategories = {
    LANDING_PAGE: 'bk_event_offer@landingpage',
    SEARCH_RESULT_PAGE: 'bk_event_offer@results',
    DETAIL_PAGE: 'bk_event_offer@eventdetailpage',
}

export enum pdpPageCategories {
    PDP_PAGE = 'property_details',
    PDP_PAGE_COMBO = 'property_details_comboListing',
}

export enum objectOverviewPageCategories {
    OBJECT_OVERVIEW_PAGE = 'object_overview_page',
    OBJECT_CLICK = 'click_object_overview_card',
    BUTTON_CLICK = 'click_object_overview_button',
}

export const inquirySuccessPageCategories = {
    BOOKING_SUCCESS: 'booking_success',
    LIFE_TERRA: 'lifeterra',
    HOST_SECTION: 'host_section',
    SWIFTCOVER: 'swiftcover',
    LEAD_SHARING: 'lead_sharing',
}

export const pageTypeEventCategories = {
    HOME: 'home',
    REGION_LANDING_PAGE: 'region_landing_page',
    PROPERTY_DETAILS_PAGE: 'property_details_page',
    OBJECT_OVERVIEW_PAGE: 'object_overview_page',
    LEAD_SHARING_PAGE: 'lead_sharing_page',
    INQUIRY_SUCCESS_PAGE: 'inquiry_success_page',
    SEARCH_RESULT_LISTING_PAGE: 'search_result_listing_page',
    WISHLIST_PAGE: 'wishlist_page',
}

export const cardEventCategories = {
    sections: {
        TOP_RECOMMENDATIONS: 'top_recommendations_section',
        TOP_OFFERS: 'top_offers_section',
        CONTINUE_SEARCH: 'continue_search_section',
        POPULAR_FILTER_LISTINGS: 'popular_filter_listings_section',
        SIMILAR_PROPERTIES: 'similar_properties_section',
        LISTINGS: 'listings_section',
        POPUP: 'popup_section',
        REVIEW: 'review_section',
        LEAD_SHARING_LISTING: 'lead_sharing_listing_section',
        POPULAR_SEARCHES: 'popular_searches_section',
        LISTING_CARD: 'listing_card_section',
        RECENT_SEARCHES: 'recent_searches_section',
        HIDDEN_GEM_CAROUSEL: 'hg_carousel',
    },
}
